import React from "react";
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import useMediaQuery from '@mui/material/useMediaQuery';

function Box({ children }) {
    return (
        <div       
         style={{ 
        display: 'block',
        lineHeight: 1,             
        marginBottom: '8px',
        width: '100%',
      }}         
        >
            {children}
        </div>
    );
}


const CancelPolicySkeleton = (props) => {
    const md = useMediaQuery('(max-width: 768px)');
    return (
        <div className="CancellationPolicyInfoDiv" style={{marginTop:'16px'} }>
            <div className="r_additionalInfoElement" style={{ border: 'none' }}>
                <SkeletonTheme baseColor="#D8DBE0" highlightColor="#EDF1F6" borderRadius={'4px'}>
                    <div style={{marginBottom:'24px'} }> 
                        <Skeleton height={31} width={160} />
                    </div>
                    <div style={{marginBottom:'24px'}}>
                        <Skeleton wrapper={Box} count={2} width={md ? '100%' : '45%'} height={16} />
                    </div>
                    <Skeleton wrapper={Box} height={16} />
                </SkeletonTheme>
            </div>
        </div>
    );
}

export default CancelPolicySkeleton;